export const ButtonTop = {
    init: function () {
      this.cacheSelectors();
      this.bindEvents();
    },
  
    cacheSelectors: function () {
      this.btnTop = document.getElementById('btnTop');
      if (!this.btnTop) {
        return;
      }
    },
  
    bindEvents: function () {
      window.addEventListener('scroll', this.Events.handleScroll.bind(this));
      if(this.btnTop){
        this.btnTop.addEventListener('click', this.Events.handleClick.bind(this));
      }
    },
  
    Events: {
      handleScroll: function () {
        if (!this.btnTop) return;
        if (window.scrollY > 100) {
          this.btnTop.style.display = 'block';
        } else {
          this.btnTop.style.display = 'none';
        }
      },
  
      handleClick: function () {
        this.smoothScrollTo(0, 0, 600);
      }
    },
  
    smoothScrollTo: function (endX, endY, duration) {
      const startX = window.scrollX || window.pageXOffset;
      const startY = window.scrollY || window.pageYOffset;
      const distanceX = endX - startX;
      const distanceY = endY - startY;
      const startTime = performance.now();
  
      const scrollStep = (currentTime) => {
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
  
        window.scrollTo(
          startX + distanceX * progress,
          startY + distanceY * progress
        );
  
        if (timeElapsed < duration) {
          requestAnimationFrame(scrollStep);
        }
      };
  
      requestAnimationFrame(scrollStep);
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    ButtonTop.init();
  });
  